import { render, staticRenderFns } from "./CardOrderDetailsComponent.vue?vue&type=template&id=c9ce5df8&"
import script from "./CardOrderDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./CardOrderDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports